var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"msglist"},[_c('search'),_c('chatlist')],1),_c('div',{staticClass:"chatbox"},[_c('message'),_c('v-text')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }